import React from 'react'
import logo from '../Images/TradeMateLogoTransparent.png';

export const Header = () => {
  return (
    <div className='header'>
        <div className='logo'>
          <img src={logo} alt="logo"/>
        </div>
        <p>Shop With Ease And Confidence</p>
    </div>
  )
}
